import { Anchor, Box, Card, Center, Group, Stack, Text, Title } from "@mantine/core";
import { IconChevronRight } from "@tabler/icons-react";
import { Link } from "react-router-dom";
import { useAppSelector } from "../store/hooks";
import { GENERATORS, galleryPath, generatePath } from "../config/generators";
import { GalleryGrid, Page } from "../components/ui";

const quickAccessItems = [
  ...GENERATORS.map((g) => ({ title: "Gallery", subtitle: g.label, description: g.galleryDescription, icon: g.icon, to: galleryPath(g) })),
  ...GENERATORS.map((g) => ({ title: "Generate", subtitle: g.label, description: g.generateDescription, icon: g.icon, to: generatePath(g) })),
];

export default function HomePage() {
  const isAuthenticated = useAppSelector((s) => s.auth.isAuthenticated);

  if (!isAuthenticated) {
    return (
      <Center h={400}>
        <Stack align="center" gap="xs">
          <Title order={1}>Unauthorized</Title>
          <Text c="dimmed" size="lg" ta="center">
            Please{" "}
            <Anchor component={Link} to="/account" fw={500}>
              log in to your account
            </Anchor>
          </Text>
        </Stack>
      </Center>
    );
  }

  return (
    <Page title="Home" description="Quick access to your gallery and generation flows.">
      <GalleryGrid cols={{ base: 1, sm: 2, md: 3 }} spacing="lg">
        {quickAccessItems.map(({ title, subtitle, description, icon: Icon, to }) => (
          <Card key={to} className="hover-card" component={Link} to={to} style={{ textDecoration: "none" }}>
            <Stack gap="md">
              <Box
                w={44}
                h={44}
                style={{
                  borderRadius: 12,
                  display: "grid",
                  placeItems: "center",
                  background: "var(--mantine-color-brand-light)",
                  color: "var(--mantine-color-brand-text)",
                }}
              >
                <Icon size={22} />
              </Box>
              <Stack gap={2}>
                <Text c="dimmed" size="xs" tt="uppercase" fw={700}>
                  {title}
                </Text>
                <Title order={3}>{subtitle}</Title>
              </Stack>
              <Text c="dimmed" size="sm">
                {description}
              </Text>
              <Group gap={4}>
                <Text fw={600} size="sm" c="brand">
                  Open
                </Text>
                <IconChevronRight size={14} style={{ verticalAlign: "middle" }} />
              </Group>
            </Stack>
          </Card>
        ))}
      </GalleryGrid>
    </Page>
  );
}
